import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_3 = { class: "collapse show" }
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract", -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claim No", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select Claim No", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Claim-1", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Claim-2", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Claim-3", -1)
const _hoisted_20 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "row mt-3" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "col-md-2 mt-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "card mt-15 mb-xl-10"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#upload_file",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Upload File ")
  ])
], -1)
const _hoisted_29 = {
  id: "upload_file",
  class: "collapse show"
}
const _hoisted_30 = { class: "collapse show" }
const _hoisted_31 = { class: "card-body border-top p-4" }
const _hoisted_32 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Upload File", -1)
const _hoisted_36 = { class: "col-md-2 mt-7 text-center" }
const _hoisted_37 = { class: "indicator-label" }
const _hoisted_38 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "card mb-5 mb-xl-10" }
const _hoisted_41 = {
  id: "assessor_data",
  class: "collapse show"
}
const _hoisted_42 = { class: "collapse show" }
const _hoisted_43 = { class: "card-body border-top p-6" }
const _hoisted_44 = { class: "table-responsive mt-5" }
const _hoisted_45 = { class: "table table-borderless gy-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Partner"),
    /*#__PURE__*/_createElementVNode("th", null, "Contract"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim No "),
    /*#__PURE__*/_createElementVNode("th", null, "Bill No "),
    /*#__PURE__*/_createElementVNode("th", null, "Download")
  ])
], -1)
const _hoisted_47 = { style: {} }
const _hoisted_48 = { class: "align-middle" }
const _hoisted_49 = { class: "align-middle" }
const _hoisted_50 = { class: "align-middle" }
const _hoisted_51 = { class: "align-middle" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = { class: "align-middle" }
const _hoisted_56 = { class: "align-middle" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download fa-lg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_Form, {
    class: "form",
    "validation-schema": _ctx.AssessorSchema
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _hoisted_9,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.bill.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bill.tranche_id) = $event)),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: trans.id,
                            label: trans.label,
                            value: trans.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(trans.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Partner",
                      modelValue: _ctx.bill.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bill.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getEntityContract()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.entity_short_name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("[" + _toDisplayString(data.entity_short_name) + "]-" + _toDisplayString(data.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Contract",
                      modelValue: _ctx.bill.entity_contract_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bill.entity_contract_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractInfos, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.contract_name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.contract_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      placeholder: "Select Claim No",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bill.claim_no) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getAllBillNo()))
                    }, _hoisted_20, 544), [
                      [_vModelSelect, _ctx.bill.claim_no]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _hoisted_24,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Bill",
                      modelValue: _ctx.bill.bill_sequence_no,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bill.bill_sequence_no) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBillNo, (bl) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: bl.bill_no,
                            label: bl.bill_no,
                            value:  bl.bill_no
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(bl.bill_no), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getList())),
                      type: "button",
                      class: "btn btn-success mt-4 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Next "),
                      _hoisted_26
                    ])
                  ])
                ]),
                (_ctx.showSection == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _hoisted_35,
                                  _createElementVNode("input", {
                                    type: "file",
                                    class: "form-control",
                                    id: "mobile",
                                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ( _ctx.handleFileChange  &&  _ctx.handleFileChange (...args))),
                                    accept: ".pdf"
                                  }, null, 32)
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("button", {
                                    class: "btn btn-lg btn-success",
                                    type: "button",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formSubmit()))
                                  }, [
                                    _createElementVNode("span", _hoisted_37, [
                                      _createTextVNode(" Submit "),
                                      _createElementVNode("span", _hoisted_38, [
                                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(), _createElementBlock("div", {
                  key: _ctx.claimBillkey 
                }, [
                  ( _ctx.showSection == true )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("table", _hoisted_45, [
                                    _hoisted_46,
                                    _createElementVNode("tbody", _hoisted_47, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBillNo, (data, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: index,
                                          style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"}
                                        }, [
                                          _createElementVNode("td", _hoisted_48, _toDisplayString(index + 1), 1),
                                          _createElementVNode("td", _hoisted_49, _toDisplayString(data?.entity_info?.entity_short_name), 1),
                                          _createElementVNode("td", _hoisted_50, _toDisplayString(data?.contract_info?.contract_name), 1),
                                          _createElementVNode("td", _hoisted_51, [
                                            (data?.claim_no == 1)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Claim-1"))
                                              : _createCommentVNode("", true),
                                            (data?.claim_no == 2)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_53, "Claim-2"))
                                              : _createCommentVNode("", true),
                                            (data?.claim_no == 3)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_54, "Claim-3"))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("td", _hoisted_55, _toDisplayString(data?.bill_no), 1),
                                          _createElementVNode("td", _hoisted_56, [
                                            _createElementVNode("a", {
                                              onClick: ($event: any) => (_ctx.downloadFile(data?.attach_file.file_path)),
                                              class: "btn btn-sm btn-success"
                                            }, [
                                              _hoisted_58,
                                              _createTextVNode(" Download ")
                                            ], 8, _hoisted_57)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"])), [
    [_directive_loading, _ctx.loading]
  ])
}